<template lang="pug">
    .field-payment-method-id(v-if="$is('payment-method-id')")
        .label ID
        .field-value {{item.id}} {{item.uid}}
    .field-payment-method-id(v-else-if="$is('payment-method-name')")
        .label Payment method Name
        .field-value
            a(v-on:click="viewPMOnGateway") {{item.name}}
    .field-payment-method-id(v-else-if="$is('payment-method-provider')")
        .label Provider
        .field-value
            a(v-on:click="viewClientOnGateway") {{item.provider}}
    .field-payment-method-id(v-else-if="$is('payment-method-created')")
        .label Created
        .field-value {{$dateFormat(item.created,"DD/MM/YYYY hh:mm")}}
    .field-payment-method-id(v-else-if="$is('payment-method-updated')")
        .label Updated
        .field-value {{$dateFormat(item.updated,"DD/MM/YYYY hh:mm")}}

</template>
<script type="text/babel">
    export default {
        name: "PaymentMethodFields",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            viewPMOnGateway() {
                var url = GatewayUrlHelper.paymentMethod(this.item.provider, this.item.data.braintree_card_token);
                window.open(url, '_blank')
            },
            viewClientOnGateway() {
                var url = GatewayUrlHelper.clientUrl(this.item.provider, this.item.data.braintree_client_id);
                window.open(url, '_blank')
            }
        },
        computed: {
            type() {
                return this.fieldName
            }
        },
        props: {
            item: Object,
            fieldName: {
                type: String,
                default: ''
            }
        },
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// PaymentMethodFields.vue?1ee2f86f